import { Pipe, PipeTransform } from '@angular/core';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';

@Pipe({
    name: 'getLaunchButtonLabel',
})
export class GetLaunchButtonLabelPipe implements PipeTransform {
    transform(module: { type?: string; kind?: string; selfPaced?: boolean } | null | undefined): string {
        if (module?.kind === ModuleKind.ProgramExecution || module?.kind === ModuleKind.ProgramTemplate || module?.type === ModuleType.Program) {
            return 'E_LEARNING.BUTTON.LAUNCH_PROGRAM';
        }

        if (module?.type === ModuleType.ELearning || module?.selfPaced) {
            return 'E_LEARNING.BUTTON.LAUNCH_E_LEARNING';
        }

        return 'E_LEARNING.BUTTON.LAUNCH';
    }
}
